import React, { ReactElement } from 'react';
import { Heading, Link } from 'idsk-react-components';
import { useParams } from 'react-router';
import routes from '../../../routing/routes';
import { usePracovnyKrokLegislativnyMaterialContext } from '../../../context/PracovnyKrokLegislativnyMaterialContext';
import splitCisloLegMaterialu from '../../../function/splitCisloLegMaterialu';

interface Props {
  message: string;
}

const HeadingWithLink = ({ message }: Props): ReactElement => {
  const {
    type,
    year,
    index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number }>();
  const { material } = usePracovnyKrokLegislativnyMaterialContext();

  function linkEditSprievodneDokumenty(): string {
    if (material && material.cisloLegislativnehoMaterialu) {
      const {
        type: typeFromCislo,
        year: yearFromCislo,
        index: indexFromCislo,
      } = splitCisloLegMaterialu(material.cisloLegislativnehoMaterialu);
      return routes.procesy.detail.sprievodneDokumenty.edit.withParams(typeFromCislo, yearFromCislo, indexFromCislo);
    }
    return routes.procesy.detail.sprievodneDokumenty.edit.withParams(type, year, index);
  }

  if (message && message.includes('Akciu nie je možné vykonať, k materiálu nie sú pridané všetky '
    + 'povinné sprievodné dokumenty.')) {
    return (
      <Heading
        className="client-error-message__heading"
        size="m"
      >Akciu nie je možné vykonať, k materiálu nie sú pridané všetky povinné&nbsp;
        <Link
          size="medium"
          to={linkEditSprievodneDokumenty()}
        >
          sprievodné dokumenty
        </Link>. Prosím, pridajte sprievodné dokumenty typu:
        <ul>
          {message.split('sprievodné dokumenty typu: ')[1].slice(0, -1)
            .split(', ')
            .map(
              (sprievodnyDokument) => (
                // eslint-disable-next-line react/no-array-index-key
                <li key={sprievodnyDokument}>{sprievodnyDokument}</li>
              ),
            )}
        </ul>
      </Heading>
    );
  }
  return (
    <Heading
      className="client-error-message__heading"
      size="m"
    >{message}
    </Heading>
  );
};

export default HeadingWithLink;
